<template>
  <div style="height: 100%" v-if="isLoaded">
    <zone-container-thermostat
      id="thermostat"
      :zone="zone"
      :installationId="installation['.key']"
    ></zone-container-thermostat>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ZoneContainerThermostat from "../../../../components/installations/zones/container/ZoneContainerThermostat";

export default {
  components: {
    ZoneContainerThermostat,
  },
  name: "zone-temp",

  data() {
    return {
      isLoaded: false,
    };
  },
  computed: {
    ...mapState("zones", {
      zone: "current",
    }),
    ...mapState("installations", {
      installation: "current",
    }),
  },

  methods: {
    ...mapActions("installations", {
      setInstallation: "setCurrent",
    }),

    ...mapActions("zones", {
      setZone: "setCurrent",
      setStatistics: "setStatistics",
    }),

    goBack: function () {
      this.$router.push(
        "/installations/" +
          this.installation[".key"] +
          "/zone/" +
          this.zone.path.split("/")[this.zone.path.split("/").length - 1]
      );
    },

    loadZone: function () {
      this.setInstallation(this.$route.params.id)
        .then(() => {
          this.setZone(this.$route.params.idZone).then(() => {
            this.isLoaded = true;
          });
        })
        .catch(() => {
          this.$router.push("/installations");
        });
    },
  },

  mounted: function () {
    this.loadZone();
  },
};
</script>

<style lang="scss" scoped></style>
